import script from "./CategoriesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriesSection.vue?vue&type=script&setup=true&lang=js"

import "./CategoriesSection.vue?vue&type=style&index=0&id=6577bee4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6577bee4"]])

export default __exports__